var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagKyrgyzstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1691_40006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8691 12L15.4712 13.1279L16.7481 15.4504L14.144 14.9522L13.8142 17.5826L12.0004 15.6481L10.1867 17.5826L9.85676 14.9522L7.25295 15.4503L8.52982 13.1278L6.13184 12L8.52982 10.8721L7.25295 8.54956L9.85666 9.04784L10.1868 6.41736L12.0004 8.35194L13.8143 6.41736L14.144 9.04784L16.7482 8.54956L15.4712 10.8723L17.8691 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 15.6521C14.0169 15.6521 15.652 14.017 15.652 11.9999C15.652 9.98291 14.0169 8.34778 11.9998 8.34778C9.98279 8.34778 8.34766 9.98291 8.34766 11.9999C8.34766 14.017 9.98279 15.6521 11.9998 15.6521Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1737 12C10.0857 12 9.99882 12.0045 9.91309 12.013C9.91623 12.5189 10.0992 12.9818 10.4015 13.3415C10.5627 12.9076 10.8035 12.5119 11.1071 12.1733C10.8171 12.0618 10.5025 12 10.1737 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2979 13.9657C11.5172 14.0441 11.7534 14.0871 11.9998 14.0871C12.2462 14.0871 12.4824 14.0441 12.7018 13.9657C12.5822 13.4964 12.3353 13.0774 11.9998 12.7482C11.6643 13.0774 11.4174 13.4964 11.2979 13.9657Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8069 10.9569C13.4461 10.3332 12.7721 9.91309 11.9996 9.91309C11.2271 9.91309 10.5532 10.3331 10.1924 10.9569C10.8502 10.9602 11.4671 11.1391 11.9996 11.448C12.5322 11.1391 13.149 10.9602 13.8069 10.9569Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8926 12.1734C13.1962 12.512 13.4369 12.9077 13.5982 13.3416C13.9004 12.982 14.0834 12.519 14.0866 12.0132C14.0008 12.0046 13.9139 12.0001 13.826 12.0001C13.4972 12.0001 13.1826 12.0619 12.8926 12.1734Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_40006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKyrgyzstan);
export default __webpack_public_path__ + "static/media/flag-kyrgyzstan.02ace09245df58fcd5e6909f86df11ff.svg";
export { ForwardRef as ReactComponent };